<h4 mat-dialog-title>
  <span *ngIf="!data;else editHeader">
    Crea nuova preferenza agenzia
  </span>
  <ng-template #editHeader>
    Modifica preferenza agenzia
  </ng-template>
</h4>
<form *ngIf="form" [formGroup]="form" class="mt-4" (keydown.enter)="edit()">

  <mat-form-field>
    <mat-label>Agenzia</mat-label>
    <agenzia-picker formControlName="agenzia"></agenzia-picker>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Incaricato</mat-label>
    <user-picker formControlName="incaricato"></user-picker>
  </mat-form-field>
</form>
<button mat-raised-button (click)="edit()" color="primary">Salva</button>
